import { Functions } from 'firebase/functions';
import { environment } from '../../environments/environment';
import { RefreshCredentialAdapterInteractor } from '../auth/domain/interactors/refresh-credential.interactor';
import { CommonProvider } from '../common/common.provider';
import { ExchangeGoogleAuthCodeInteractor } from './domain/exchange-google-auth-code.interactor';
import { LoginWithPopupGoogleAdapterInteractor } from './domain/login-with-popup-google-adapter.interactor';
import { RefreshGoogleCredentialInteractor } from './domain/refresh-google-credential.interactor';
import { Cached, ServiceAuthType } from '@uploadcam/common';
import { LoginWithRedirectAdapterInteractor } from '../auth/domain/interactors/login-with-redirect.interactor';
import { LoginWithRedirectGoogleAdapterInteractor } from './domain/login-with-redirect-google-adapter.interactor';
import { ExchangeAuthCodeInteractor } from '../auth/domain/interactors/exchange-auth-code.interactor';
import { LoginWithPopupAdapterInteractor } from '../auth/domain/interactors/login-with-popup-adapter.interactor';

export const GOOGLE_DRIVE_FULL_ACCESS_SCOPE = 'https://www.googleapis.com/auth/drive';

export abstract class AuthGoogleProvider {
  abstract provideExchangeGoogleAuthCode(): ExchangeAuthCodeInteractor;
  abstract provideLoginWithPopupGoogleAdapter(): LoginWithPopupAdapterInteractor;
  abstract provideLoginWithRedirectGoogleAdapter(): LoginWithRedirectAdapterInteractor;
  abstract provideRefreshGoogleCredential(): RefreshCredentialAdapterInteractor;
  abstract provideRequiredScopes(): readonly string[];
}

export class AuthGoogleDefaultProvider implements AuthGoogleProvider {
  private readonly scopes = [
    'https://www.googleapis.com/auth/userinfo.email',
    'https://www.googleapis.com/auth/userinfo.profile',
    'https://www.googleapis.com/auth/drive.file',
  ];

  constructor(
    private readonly common: CommonProvider,
    private readonly functions: Functions,
  ) {}

  @Cached()
  public provideExchangeGoogleAuthCode(): ExchangeAuthCodeInteractor {
    return new ExchangeGoogleAuthCodeInteractor(
      environment.google.clientId,
      this.functions,
      this.common.provideOAuthRedirectUri(ServiceAuthType.Google),
      environment.baseUrl,
    );
  }

  @Cached()
  public provideLoginWithPopupGoogleAdapter(): LoginWithPopupAdapterInteractor {
    return new LoginWithPopupGoogleAdapterInteractor(
      environment.google.clientId,
      this.common.provideGoogleIdentityService(),
      this.scopes,
    );
  }

  @Cached()
  public provideLoginWithRedirectGoogleAdapter(): LoginWithRedirectAdapterInteractor {
    return new LoginWithRedirectGoogleAdapterInteractor(
      environment.google.clientId,
      this.common.provideGoogleIdentityService(),
      this.common.provideOAuthRedirectUri(ServiceAuthType.Google),
      this.scopes,
    );
  }

  @Cached()
  public provideRefreshGoogleCredential(): RefreshCredentialAdapterInteractor {
    return new RefreshGoogleCredentialInteractor(environment.google.clientId, this.functions);
  }

  public provideRequiredScopes(): readonly string[] {
    return this.scopes;
  }
}
